/**
 * Format duration in minutes to human-readable string
 * e.g. 300 -> "5 Hours", 90 -> "1 Hour 30 Mins", 45 -> "45 Mins"
 */
export const formatDuration = (minutes) => {
  if (!minutes) return '';
  const mins = Number(minutes);
  if (mins < 60) return `${mins} Mins`;
  const hours = Math.floor(mins / 60);
  const remainder = mins % 60;
  const hourLabel = hours === 1 ? 'Hour' : 'Hours';
  if (remainder === 0) return `${hours} ${hourLabel}`;
  return `${hours} ${hourLabel} ${remainder} Mins`;
};

export default formatDuration;
